/**
 * @Author: Scott Fogelgren
 * @Date:   2019-03-08T17:50:00-05:00
 * @Email:  sfogelgren@comsearch.com
 * @Project: Project Insight
 * @Last modified by:   Scott Fogelgren
 * @Last modified time: 2019-03-08T17:53:03-05:00
 * @Copyright: // Copyright (c) 2019 Comsearch, Inc., All rights reserved
 */
export const marketingUrlRoot = 'https://comsearch.com'
